module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav "
  }, _vm._l((_vm.menuList), function(menu) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'Home'
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-th-large"
    }), _vm._v(" "), _c('span', {
      staticClass: "nav-label"
    }, [_vm._v(_vm._s(menu.name))]), _vm._v("aaa\n    ")]), _vm._v("\n      vv"), _c('router-link', {
      attrs: {
        "to": menu.link
      }
    }, [_c('i', {
      staticClass: "fa fa-th-large"
    }), _vm._v(" "), _c('span', {
      staticClass: "nav-label"
    }, [_vm._v(_vm._s(menu.name))])])], 1)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47397c98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideMenu.vue
// module id = 451
// module chunks = 1